
<section class="containerDetail">
    <h1 class="title">Resumen de pedido</h1>
    <app-resumen-item ></app-resumen-item>
</section>
